"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var _1 = require("./");
var FlightReminderButtonComponent = (function () {
    function FlightReminderButtonComponent() {
        this.buttonClickedEmitter = new core_1.EventEmitter();
    }
    FlightReminderButtonComponent.prototype.ngOnInit = function () {
        if (this.policies && this.policy) {
            throw new TypeError('Please provied only one input for IApiQuoteResponseModel([]) (policies or policy)');
        }
    };
    FlightReminderButtonComponent.prototype.buttonClicked = function (policyNumber) {
        this.buttonClickedEmitter.emit(policyNumber);
    };
    FlightReminderButtonComponent.prototype.checkPolicyForFlightReminder = function (policyFlightOverride) {
        if (policyFlightOverride.flightCount === 0 && policyFlightOverride.futureFlightsExpected === true) {
            return true;
        }
        return false;
    };
    return FlightReminderButtonComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], FlightReminderButtonComponent.prototype, "policies", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", _1.PolicyFlightOverride)
], FlightReminderButtonComponent.prototype, "policy", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], FlightReminderButtonComponent.prototype, "buttonText", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], FlightReminderButtonComponent.prototype, "buttonClickedEmitter", void 0);
FlightReminderButtonComponent = __decorate([
    core_1.Component({
        selector: 'flight-reminder-button',
        template: "<div *ngIf=\"policies\">     <div *ngFor=\"let policy of policies\">         <button class=\"btn btn-success add-my-flights-button\"                 (click)=\"buttonClicked(policy.policyNumber)\"                 *ngIf=\"checkPolicyForFlightReminder(policy)\">             <span class=\"fa fa-plus-circle\"></span>             {{buttonText}}<span *ngIf=\"policies?.length > 1\"> {{policy.policyNumber}}</span>         </button>     </div> </div> <div *ngIf=\"policy\">     <button class=\"btn btn-success add-my-flights-button\"             (click)=\"buttonClicked(policy.policyNumber)\">         <span class=\"fa fa-plus-circle\"></span>         {{buttonText}}     </button> </div>"
    }),
    __metadata("design:paramtypes", [])
], FlightReminderButtonComponent);
exports.FlightReminderButtonComponent = FlightReminderButtonComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/flight-reminder/flight-reminder-button.component.js